<template>
  <div
    id="app"
    :class="{
      noscroll: this.$route.meta.panel,
      'sitemap-on': showSitemap,
    }"
  >
    <Ticker v-if="showTicker" />

    <div id="top-bar" class="sticky z2" :class="{ 'z4 nobg': showSitemap }">
      <div
        id="hamburger"
        class="icon pointer z4 hide-print"
        @click="UPDATE_SITEMAP()"
      >
        <img v-if="!showSitemap" src="@/assets/icon-hamburger.svg" alt="" />
        <transition name="rotate-fade">
          <img v-if="showSitemap" src="@/assets/icon-close.svg" alt="" />
        </transition>
      </div>
      <transition name="fade">
        <site-map v-if="showSitemap" @close="hideSitemap"></site-map>
      </transition>

      <div id="top-right">
        <router-link
          id="donate-button"
          :to="{ name: 'About', params: { page: 'donate' } }"
        >
          Donate</router-link
        >
        <div
          class="hover-red pointer z4 hide-print"
          @click="UPDATE_SHOW_SEARCH()"
        >
          <span class="xs-hide"
            ><span class="caps">Search</span>&nbsp;<span v-if="searchQuery"
              >({{ searchQuery }})</span
            ></span
          >
          <img
            class="search-icon sm-hide md-hide lg-hide"
            height="22"
            width="22"
            src="@/assets/icon-search.svg"
          />
        </div>
      </div>
    </div>

    <Search v-show="showSearch" :showSearch="showSearch"></Search>

    <div
      v-if="showLogo()"
      class="logo-wrapper center mx-auto z1 flex items-center justify-around relative col-12"
    >
      <router-link :to="{ name: 'Investigations' }">
        <img src="/forensis-logo.png" id="logo" />
      </router-link>
    </div>

    <Menu></Menu>

    <video-player></video-player>

    <Map v-if="showMap"></Map>

    <router-view />
    <router-view name="footer"></router-view>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Menu from "@/components/Menu";
import SiteMap from "@/components/SiteMap";
import Map from "@/components/Map";
import Search from "@/components/Search";
import VideoPlayer from "@/components/VideoPlayer";
import Ticker from "@/components/Ticker";

export default {
  name: "app",

  metaInfo: {
    title: "Investigations",
    titleTemplate: `%s ← ${process.env.VUE_APP_TITLE}`,
  },

  data() {
    return {
      aboutLine: "",
    };
  },

  components: {
    Map,
    Menu,
    Search,
    SiteMap,
    VideoPlayer,
    Ticker,
  },

  computed: {
    ...mapState([
      "aboutLines",
      "showMap",
      "showSearch",
      "showSitemap",
      "investigations",
      "searchQuery",
      "showSitemap",
      "site",
    ]),
    showTicker() {
      return this.$route.name === "Investigations";
    },
  },

  methods: {
    ...mapMutations(["UPDATE_SHOW_SEARCH", "UPDATE_SITEMAP"]),
    hideSearch() {
      this.$store.commit("UPDATE_SHOW_SEARCH", "hide");
    },
    hideSitemap() {
      this.$store.commit("UPDATE_SITEMAP", "hide");
    },
    updateAboutLine() {
      this.aboutLine =
        this.aboutLines[
          Math.floor(Math.random() * this.aboutLines.length)
        ].text;
    },
    showLogo() {
      return this.$route.meta.logo ? this.$route.meta.logo : false;
    },
  },

  watch: {
    $route() {
      this.hideSearch();
    },
    aboutLines() {
      this.updateAboutLine();
    },
  },
};
</script>

<style>
@import "css/app.css";

#logo {
  width: 114px;
}

#top-bar {
  background: var(--col-light);
  height: 46px;

  &.nobg {
    background: transparent;
  }
}

#hamburger {
  z-index: 9999;
  position: absolute;
  padding: 0.5em;
  top: 0.5em;
  left: 0.5em;
  transform: scale3d(1, 1, 1);
  transition: transform 0.1s ease-out;
}

#top-right {
  position: absolute;
  padding: 0.5em;
  top: 0.4em;
  right: 0.5em;
  transition: transform 0.2s ease-out;
  z-index: 1000;
  display: flex;
  gap: 1em;
}

#donate-button {
  color: red;
  border: 1px solid red;
  padding: 0.2em 0.5em;
  margin-top: -0.25em;
  text-transform: uppercase;

  &:hover {
    background: red;
    color: white;
  }
}

.search-icon {
  height: 22px;
  width: 22px;
  margin-top: -0.1em;
}

.sitemap-on {
  #hamburger {
    position: fixed;
  }
}
</style>
